import React from "react";
import "./bio.scss";

export const Biography = () => {
  return (
		<section className="right-section not-home-page">
				<div className="wrapper">
				    <img src="imgs/vitor-p-t.jpg" alt="Vitor P. Teixeria" className="bio-image"/>
				    <p className="about-text">A passionate photographer, I began my professional career in Rio de Janeiro, creating fashion editorials for a local, avant-garde fashion brand. Working with black and white film, I developed and printed the images in my own darkroom, which I built in my apartment. Now working in digital photography, primarily as a studio photographer, I enjoy experimenting with lighting effects, composition, and post-production techniques.</p>
				</div>
		</section>
  )
};
